define('dcf-gallery',["exports", "./dcf-utility", "./dcf-modal"], function (_exports, _dcfUtility, _dcfModal) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.DCFGalleryImageTheme = _exports.DCFGalleryImage = void 0;
  function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
  function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
  function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
  var DCFGalleryImageTheme = /*#__PURE__*/function () {
    function DCFGalleryImageTheme() {
      _classCallCheck(this, DCFGalleryImageTheme);
    }

    // Allows us to set the theme variables if they are defined and we match the types
    _createClass(DCFGalleryImageTheme, [{
      key: "setThemeVariable",
      value: function setThemeVariable(themeVariableName, value) {
        if (themeVariableName in this && _typeof(value) == _typeof(this[themeVariableName])) {
          this[themeVariableName] = value;
        }
      }
    }]);
    return DCFGalleryImageTheme;
  }();
  _exports.DCFGalleryImageTheme = DCFGalleryImageTheme;
  var DCFGalleryImage = /*#__PURE__*/function () {
    // Set up the button
    function DCFGalleryImage(galleryImages, theme, bodyScrollLock) {
      _classCallCheck(this, DCFGalleryImage);
      if (theme instanceof DCFGalleryImageTheme) {
        this.theme = theme;
      } else {
        this.theme = new DCFGalleryImageTheme();
      }

      // Create a random ID for the button
      this.uuid = _dcfUtility.DCFUtility.uuidv4();
      this.bodyScrollLock = bodyScrollLock;
      this.modalId = this.uuid.concat('-gallery-modal');
      this.galleryImageRunningTotal = 0;

      // Store the gallery images inputted (always will be an array )
      /** @type {Array<HTMLImageElement>} */
      this.galleryImages = galleryImages;
      if (NodeList.prototype.isPrototypeOf(this.galleryImages)) {
        this.galleryImages = Array.from(this.galleryImages);
      } else if (!Array.isArray(this.galleryImages)) {
        this.galleryImages = [this.galleryImages];
      }
    }

    // The names of the events to be used easily
    _createClass(DCFGalleryImage, [{
      key: "initialize",
      value: function initialize() {
        var _this = this;
        var modalDiv = this.createEmptyModal();
        document.body.append(modalDiv);
        this.modalObj = new _dcfModal.DCFModal([modalDiv], this.bodyScrollLock);
        this.modalObj.initialize();
        this.createModalEventListeners(modalDiv);
        var modalPrevButton = modalDiv.querySelector('.dcf-gallery-btn-prev');
        var modalNextButton = modalDiv.querySelector('.dcf-gallery-btn-next');
        modalPrevButton.addEventListener('click', function () {
          _this.previousImageForModal();
        });
        modalNextButton.addEventListener('click', function () {
          _this.nextImageForModal();
        });

        // Loops through each one
        this.galleryImages.forEach(function (galleryImage) {
          if (!('tagName' in galleryImage) || galleryImage.tagName !== 'IMG') {
            throw new Error("Gallery image is not an image: \n \"".concat(galleryImage.outerHTML, "\""));
          }
          _this.addNewGalleryImage(galleryImage);
        });
      }

      /**
       * @returns { HTMLDivElement }
       */
    }, {
      key: "createEmptyModal",
      value: function createEmptyModal() {
        var modalDiv = document.createElement('div');
        modalDiv.classList.add('dcf-modal');
        modalDiv.dataset.galleryImage = 'galleryImage';
        modalDiv.setAttribute('id', this.modalId);
        modalDiv.setAttribute('hidden', 'hidden');
        modalDiv.innerHTML = "\n    <div class=\"dcf-modal-wrapper dcf-relative dcf-d-flex dcf-flex-col dcf-h-100%\">\n      <div class=\"dcf-modal-header dcf-modal-header-gallery dcf-flex-shrink-0 dcf-d-flex dcf-jc-flex-end\">\n        <h2 class=\"dcf-sr-only\">Image Gallery</h2>\n        <button class=\"dcf-btn-close-modal dcf-btn dcf-btn-tertiary\">Close</button>\n      </div>\n      <div class=\"dcf-modal-content dcf-modal-content-gallery dcf-flex-grow-1 dcf-d-grid\">\n        <div class=\"dcf-gallery-prev dcf-d-flex dcf-ai-center\">\n          <button class=\"dcf-btn dcf-btn-secondary dcf-gallery-btn-prev dcf-d-flex dcf-jc-center dcf-ai-center dcf-h-7 dcf-w-7 dcf-p-0 dcf-circle\">\n              <span class=\"dcf-sr-only\">Previous Image</span>\n              <svg xmlns=\"http://www.w3.org/2000/svg\" class=\"dcf-fill-current dcf-h-4 dcf-w-4 dcf-d-block\" style=\"rotate: 180deg;\" viewBox=\"0 0 30 36\">\n                <path d=\"M25.5,15.3L9.3,0.9C8.6,0.3,7.6,0,6.7,0c-1,0.1-1.9,0.5-2.5,1.2\n                C3.5,2,3.2,2.9,3.3,3.8c0.1,1,0.5,1.9,1.2,2.5L17.7,18\n                L4.5,29.7c-0.7,0.6-1.2,1.5-1.2,2.5c-0.1,1,0.3,1.9,0.9,2.6\n                C4.8,35.5,5.8,36,6.9,36c0.9,0,1.7-0.3,2.4-0.9l16.3-14.4\n                c0.8-0.7,1.2-1.7,1.2-2.7S26.3,16,25.5,15.3z\"/>\n              </svg>\n          </button>\n        </div>\n        <div class=\"dcf-gallery-next dcf-d-flex dcf-ai-center\">\n          <button\n          class=\"dcf-btn dcf-btn-secondary dcf-gallery-btn-next dcf-d-flex dcf-jc-center dcf-ai-center dcf-h-7 dcf-w-7 dcf-p-0 dcf-circle\">\n            <span class=\"dcf-sr-only\">Next Image</span>\n            <svg xmlns=\"http://www.w3.org/2000/svg\" class=\"dcf-fill-current dcf-h-4 dcf-w-4 dcf-d-block\" viewBox=\"0 0 30 36\">\n              <path d=\"M25.5,15.3L9.3,0.9C8.6,0.3,7.6,0,6.7,0c-1,0.1-1.9,0.5-2.5,1.2\n              C3.5,2,3.2,2.9,3.3,3.8c0.1,1,0.5,1.9,1.2,2.5L17.7,18\n              L4.5,29.7c-0.7,0.6-1.2,1.5-1.2,2.5c-0.1,1,0.3,1.9,0.9,2.6\n              C4.8,35.5,5.8,36,6.9,36c0.9,0,1.7-0.3,2.4-0.9l16.3-14.4\n              c0.8-0.7,1.2-1.7,1.2-2.7S26.3,16,25.5,15.3z\"/>\n            </svg>\n          </button>\n        </div>\n        <div class=\"dcf-gallery-thumbnails dcf-overflow-y-hidden dcf-overflow-x-auto\">\n          <ul class=\"dcf-gallery-thumbnails-list dcf-d-flex dcf-flex-nowrap dcf-mb-0\" aria-label=\"images\" role=\"tablist\">\n          </ul>\n        </div>\n        <figure class=\"dcf-gallery-figure dcf-d-flex dcf-flex-col dcf-ai-center dcf-jc-center\" role=\"tabpanel\" aria-live=\"polite\">\n        </figure>\n      </div>\n    </div>\n    ";
        return modalDiv;
      }

      /**
       * @param { HTMLImageElement } imageElement New Image to be added as modal button
       */
    }, {
      key: "addNewGalleryImage",
      value: function addNewGalleryImage(imageElement) {
        if (imageElement.getAttribute('id') === null) {
          imageElement.setAttribute('id', this.uuid.concat('-gallery-', this.galleryImageRunningTotal));
        }
        imageElement.setAttribute('type', 'button');
        imageElement.dataset.ready = 'ready';
        this.galleryImageRunningTotal++;
      }

      /**
       */
    }, {
      key: "createModalEventListeners",
      value: function createModalEventListeners() {
        var _this2 = this;
        var modalPreOpenEventName = "ModalPreOpenEvent_".concat(this.modalId);
        var modalPostCloseEventName = "ModalCloseEvent_".concat(this.modalId);
        document.addEventListener(modalPreOpenEventName, this.openModal.bind(this));
        document.addEventListener(modalPostCloseEventName, this.closeModal.bind(this));
        document.addEventListener('click', function (event) {
          var closestGalleryImage = event.target.closest('img.dcf-gallery-img');
          if (closestGalleryImage === null) {
            return;
          }
          if (closestGalleryImage.dataset.ready !== 'ready') {
            _this2.addNewGalleryImage(closestGalleryImage);
          }
          _this2.modalObj.toggleModal(_this2.modalId, closestGalleryImage.getAttribute('id'));
        });
      }
    }, {
      key: "openModal",
      value: function openModal(event) {
        var _this3 = this;
        var modal = document.getElementById(this.modalId);
        if (modal === null) {
          throw new Error('Can not find gallery image modal!');
        }
        var allGalleryImages = document.querySelectorAll('img.dcf-gallery-img');
        var startingImage = event.detail.btn || null;
        if (allGalleryImages.length === _dcfUtility.DCFUtility.magicNumbers('int0')) {
          throw new Error('Can not find any gallery images!');
        }
        if (startingImage === null) {
          startingImage = allGalleryImages[_dcfUtility.DCFUtility.magicNumbers('int0')];
        }
        var list = modal.querySelector('ul');
        if (list === null) {
          throw new Error('Can not find gallery image figure!');
        }
        list.innerHTML = '';
        allGalleryImages.forEach(function (singleImage, index) {
          if (singleImage.dataset.ready !== 'ready') {
            _this3.addNewGalleryImage(singleImage);
          }
          var isSelected = false;
          if (singleImage.getAttribute('id') === startingImage.getAttribute('id')) {
            _this3.replaceMainImageForModal(singleImage);
            isSelected = true;
          }
          var singleCopiedImage = _this3.cleanImageForModal(singleImage);
          singleCopiedImage.classList.add('dcf-ratio-child', 'dcf-obj-fit-cover');
          list.innerHTML = "\n        ".concat(list.innerHTML, "\n        <li class=\"dcf-flex-shrink-0 dcf-mb-0\" role=\"tab\"\n          aria-selected=\"").concat(isSelected ? 'true' : 'false', "\"\n          aria-label=\"image ").concat(index + _dcfUtility.DCFUtility.magicNumbers('int1'), "\"\n          tabindex=\"").concat(isSelected ? '0' : '-1', "\"\n        >\n          <div class=\"dcf-ratio dcf-ratio-1x1 dcf-w-9 dcf-rounded\">\n            ").concat(singleCopiedImage.outerHTML, "\n          </div>\n        </li>\n      ");
        });
        var listItems = list.querySelectorAll('li');
        listItems.forEach(function (listItem) {
          listItem.addEventListener('click', function () {
            _this3.switchToImage(listItem);
          });
          listItem.addEventListener('keydown', function (keyboardEvent) {
            if (keyboardEvent.code === 'ArrowRight') {
              _this3.nextImageForModal(true);
            }
            if (keyboardEvent.code === 'ArrowLeft') {
              _this3.previousImageForModal(true);
            }
            if (keyboardEvent.code === 'Home') {
              _this3.switchToImage(listItems[_dcfUtility.DCFUtility.magicNumbers('int0')], true);
            }
            if (keyboardEvent.code === 'End') {
              _this3.switchToImage(listItems[listItems.length - _dcfUtility.DCFUtility.magicNumbers('int1')], true);
            }
          });
        });
      }
    }, {
      key: "closeModal",
      value: function closeModal() {
        var modal = document.getElementById(this.modalId);
        if (modal === null) {
          throw new Error('Can not find gallery image modal!');
        }
        var list = modal.querySelector('ul');
        var figure = modal.querySelector('figure');
        if (list === null) {
          throw new Error('Can not find gallery image list!');
        }
        if (figure === null) {
          throw new Error('Can not find gallery image figure!');
        }
        list.innerHTML = '';
        figure.innerHTML = '';
      }
    }, {
      key: "previousImageForModal",
      value: function previousImageForModal() {
        var focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var modal = document.getElementById(this.modalId);
        if (modal === null) {
          throw new Error('Can not find gallery image modal!');
        }
        var list = modal.querySelector('ul');
        if (list === null) {
          throw new Error('Can not find gallery image figure!');
        }
        var allImages = list.querySelectorAll('li');
        var currentImage = list.querySelector('li[aria-selected="true"]');
        var prevImage = currentImage.previousElementSibling || allImages[allImages.length - _dcfUtility.DCFUtility.magicNumbers('int1')];
        this.switchToImage(prevImage, focus);
      }
    }, {
      key: "nextImageForModal",
      value: function nextImageForModal() {
        var focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var modal = document.getElementById(this.modalId);
        if (modal === null) {
          throw new Error('Can not find gallery image modal!');
        }
        var list = modal.querySelector('ul');
        if (list === null) {
          throw new Error('Can not find gallery image figure!');
        }
        var allImages = list.querySelectorAll('li');
        var currentImage = list.querySelector('li[aria-selected="true"]');
        var nextImage = currentImage.nextElementSibling || allImages[_dcfUtility.DCFUtility.magicNumbers('int0')];
        this.switchToImage(nextImage, focus);
      }
    }, {
      key: "switchToImage",
      value: function switchToImage(newItemToSwitchTo) {
        var focus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var modal = document.getElementById(this.modalId);
        if (modal === null) {
          throw new Error('Can not find gallery image modal!');
        }
        var list = modal.querySelector('ul');
        if (list === null) {
          throw new Error('Can not find gallery image figure!');
        }
        var allImages = list.querySelectorAll('li');
        allImages.forEach(function (singleListItem) {
          singleListItem.setAttribute('tabindex', '-1');
          singleListItem.setAttribute('aria-selected', 'false');
        });
        newItemToSwitchTo.setAttribute('tabindex', '0');
        newItemToSwitchTo.setAttribute('aria-selected', 'true');
        if (focus === true) {
          newItemToSwitchTo.focus();
        }
        this.replaceMainImageForModal(newItemToSwitchTo.querySelector('img'));
      }
    }, {
      key: "replaceMainImageForModal",
      value: function replaceMainImageForModal(imageElement) {
        var modal = document.getElementById(this.modalId);
        if (modal === null) {
          throw new Error('Can not find gallery image modal!');
        }
        var figure = modal.querySelector('figure');
        if (figure === null) {
          throw new Error('Can not find gallery image figure!');
        }
        var copiedImageElement = this.cleanImageForModal(imageElement);
        figure.innerHTML = "\n      <div class=\"dcf-gallery-img-box dcf-d-flex dcf-ai-center dcf-jc-center dcf-overflow-auto\">\n        ".concat(copiedImageElement.outerHTML, "\n      </div>\n      <figcaption class=\"dcf-gallery-figcaption dcf-figcaption dcf-flex-shrink-0\">\n        <span class=\"dcf-gallery-img-cutline\">\n          ").concat(copiedImageElement.dataset.cutline || '', "\n        </span>\n        <small class=\"dcf-gallery-img-credit\">\n          ").concat(copiedImageElement.dataset.credit || '', "\n        </small>\n      </figcaption>\n    ");
      }
    }, {
      key: "cleanImageForModal",
      value: function cleanImageForModal(imageElement) {
        var copiedImageElement = imageElement.cloneNode();
        copiedImageElement.classList.remove('dcf-gallery-img', 'dcf-ratio-child', 'dcf-obj-fit-cover');
        copiedImageElement.removeAttribute('type');
        copiedImageElement.removeAttribute('disabled');
        copiedImageElement.removeAttribute('id');
        return copiedImageElement;
      }
    }], [{
      key: "events",
      value: function events(name) {
        // Define any new events
        var events = {};
        Object.freeze(events);

        // Forward the events from the DCFModal
        if (_dcfModal.DCFModal.events(name) !== undefined) {
          return _dcfModal.DCFModal.events(name);
        }

        // Return the name of the event if it exists if not it will return undefined
        return name in events ? events[name] : undefined;
      }
    }]);
    return DCFGalleryImage;
  }();
  _exports.DCFGalleryImage = DCFGalleryImage;
});

